import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        about: "About",
        products: "Products",
        technologies: "Technologies",
        industries: "Industries",
        careers: "Careers",
        blogs: "Blogs",
        testimonials: "Testimonials",
        contact: "Contact",
        demo: "Request Demo",
      },
      hero: {
        kicker: "DEEP-TECH FOR CRITICAL INFRASTRUCTURE",
        title_line1: "The End of",
        title_line2: "Electrical Downtime.",
        subtitle:
          "Olivine Global builds IoT, AI and chemistry-driven solutions for industries that cannot afford to fail — power, data centers, defense and heavy industry.",
        primary_cta: "Request a Demo",
        secondary_cta: "Explore Solutions",
      },
      trust: {
        label: "TRUSTED GLOBALLY",
        items: [
          "Korea Eco-Label Certified",
          "20 Years — Zero Safety Incidents",
          "Deployed Across America · Europe · Asia",
          "POWER-ON Cleaning up to 50,000V",
          "ISO-aligned Deep-Tech Practices",
        ],
      },
      home: {
        pillars_kicker: "WHAT WE DO",
        pillars_title: "Seven pillars of industrial deep-tech.",
        pillars_desc:
          "From live-load electrical cleaning to AI-generated training, we solve the unresolved.",
        methodology_kicker: "HOW WE DO IT",
        methodology_title: "4-Step Deep-Tech Methodology.",
        methodology_desc:
          "Every engagement is engineered, measured and verified. No guesswork.",
        cta_title: "Your plant cannot afford another shutdown.",
        cta_desc:
          "Request a site audit. Our engineers will map your risk surface and model your downtime savings.",
      },
      products: {
        title: "Products",
        subtitle: "The INSTACLEAN product line — engineered for the electrical systems that power the world.",
        instaclean_100: {
          name: "INSTACLEAN 100",
          tagline: "POWER-ON, up to 50,000V",
          bullets: [
            "Non-conductive formulation, cleans energized panels up to 50kV",
            "Ideal for HT/LT panels, CNC machines, robots, solar inverters",
            "Leaves <1 micron anti-corrosion shield",
            "Coverage ~45 sq. ft. per kg · Drying 30-40 min",
          ],
        },
        instaclean_200: {
          name: "INSTACLEAN 200",
          tagline: "Non-flammable · Zero flash point",
          bullets: [
            "Doubles as a fire extinguisher under live load",
            "Best for UPS, data-centers, underground mines, submarines",
            "Temperature reduction of 20-30% post-cleaning",
            "Coverage ~20 sq. ft. per kg · Drying 30 seconds",
          ],
        },
        instaclean_50: {
          name: "INSTACLEAN 50",
          tagline: "POWER-OFF · Severe contamination",
          bullets: [
            "Water-based, removes carbon, tar, oil, soot deposits",
            "Panel exteriors, radiator fins, rail pantographs, kitchen hoods",
            "Coverage ~125 sq. ft. per kg",
            "Biodegradable & compliance-friendly",
          ],
        },
      },
      technologies: {
        title: "Technologies",
        subtitle: "Seven capability pillars that compose every Olivine engagement.",
      },
      industries: {
        title: "Industries We Serve",
        subtitle: "Wherever uptime is non-negotiable.",
      },
      careers: {
        title: "Careers at Olivine",
        subtitle: "Join an engineering team solving problems the industry has ignored for 40 years.",
        apply: "Apply",
        open_positions: "Open Positions",
      },
      blogs: {
        title: "Insights",
        subtitle: "Field notes, research and engineering perspectives from the Olivine team.",
        read_more: "Read article",
      },
      testimonials: {
        title: "What Our Clients Say",
        subtitle: "Critical operations leaders across four continents trust Olivine.",
      },
      contact: {
        title: "Contact Us",
        subtitle: "Talk to our engineering desk.",
        name: "Full name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        submit: "Send message",
        success: "Thank you. Our team will reach out within one business day.",
        error: "Something went wrong. Please try again.",
      },
      demo: {
        title: "Request a Demo",
        subtitle: "A 45-minute technical walkthrough with our field engineers — on-site or remote.",
        role: "Your role",
        industry: "Industry",
        product: "Product of interest",
        preferred_date: "Preferred date",
        submit: "Book Demo",
        success: "Demo request received. Our team will confirm within 24 hours.",
      },
      footer: {
        tagline: "Deep technology solutions for real-world industrial challenges.",
        contact_label: "Contact",
        follow_label: "Follow",
        rights: "All rights reserved.",
      },
      admin: {
        title: "Admin Console",
        login_title: "Admin Login",
        login_cta: "Sign In",
        logout: "Logout",
        tabs: { contacts: "Contact Messages", demos: "Demo Requests", applications: "Applications" },
      },
    },
  },
  hi: {
    translation: {
      nav: {
        home: "होम",
        about: "हमारे बारे में",
        products: "उत्पाद",
        technologies: "प्रौद्योगिकियाँ",
        industries: "उद्योग",
        careers: "करियर",
        blogs: "ब्लॉग",
        testimonials: "ग्राहक समीक्षा",
        contact: "संपर्क",
        demo: "डेमो बुक करें",
      },
      hero: {
        kicker: "महत्वपूर्ण बुनियादी ढाँचे के लिए डीप-टेक",
        title_line1: "इलेक्ट्रिकल डाउनटाइम",
        title_line2: "का अंत।",
        subtitle:
          "ओलिवाइन ग्लोबल उन उद्योगों के लिए IoT, AI और केमिस्ट्री-आधारित समाधान बनाता है जो विफलता का जोखिम नहीं उठा सकते।",
        primary_cta: "डेमो बुक करें",
        secondary_cta: "समाधान देखें",
      },
      trust: {
        label: "विश्व स्तर पर विश्वसनीय",
        items: [
          "Korea Eco-Label प्रमाणित",
          "20 वर्ष — शून्य सुरक्षा घटनाएँ",
          "अमेरिका · यूरोप · एशिया में तैनात",
          "POWER-ON क्लीनिंग 50,000V तक",
          "ISO-संरेखित डीप-टेक अभ्यास",
        ],
      },
      home: {
        pillars_kicker: "हम क्या करते हैं",
        pillars_title: "औद्योगिक डीप-टेक के सात स्तंभ।",
        pillars_desc:
          "लाइव-लोड इलेक्ट्रिकल क्लीनिंग से AI-निर्मित प्रशिक्षण तक, हम अनसुलझे मुद्दे हल करते हैं।",
        methodology_kicker: "हम कैसे करते हैं",
        methodology_title: "4-चरणीय डीप-टेक पद्धति।",
        methodology_desc:
          "हर असाइनमेंट इंजीनियर, मापित और सत्यापित है। कोई अनुमान नहीं।",
        cta_title: "आपका प्लांट एक और शटडाउन नहीं झेल सकता।",
        cta_desc:
          "साइट ऑडिट का अनुरोध करें। हमारे इंजीनियर जोखिम का मानचित्रण और डाउनटाइम बचत का मॉडल बनाएँगे।",
      },
      products: {
        title: "उत्पाद",
        subtitle: "INSTACLEAN उत्पाद श्रृंखला — दुनिया को शक्ति देने वाली विद्युत प्रणालियों के लिए।",
        instaclean_100: {
          name: "INSTACLEAN 100",
          tagline: "POWER-ON, 50,000V तक",
          bullets: [
            "नॉन-कंडक्टिव, 50kV तक ऊर्जावान पैनल क्लीन",
            "HT/LT पैनल, CNC, रोबोट, सोलर इन्वर्टर के लिए आदर्श",
            "<1 माइक्रोन एंटी-कोरोशन शील्ड छोड़ता है",
            "कवरेज ~45 वर्ग फुट/किग्रा · सुखाने का समय 30-40 मिनट",
          ],
        },
        instaclean_200: {
          name: "INSTACLEAN 200",
          tagline: "गैर-ज्वलनशील · शून्य फ्लैश पॉइंट",
          bullets: [
            "लाइव लोड पर अग्निशामक के रूप में भी कार्य करता है",
            "UPS, डेटा सेंटर, खदान, पनडुब्बी के लिए सर्वोत्तम",
            "क्लीनिंग के बाद 20-30% तापमान में कमी",
            "कवरेज ~20 वर्ग फुट/किग्रा · सुखाने में 30 सेकंड",
          ],
        },
        instaclean_50: {
          name: "INSTACLEAN 50",
          tagline: "POWER-OFF · अत्यधिक संदूषण",
          bullets: [
            "वाटर-बेस्ड, कार्बन, टार, तेल, सूट हटाता है",
            "पैनल बाहरी, रेडिएटर, रेल पैंटोग्राफ, किचन हूड",
            "कवरेज ~125 वर्ग फुट/किग्रा",
            "बायोडिग्रेडेबल और अनुपालन-अनुकूल",
          ],
        },
      },
      technologies: {
        title: "प्रौद्योगिकियाँ",
        subtitle: "हर Olivine असाइनमेंट को बनाने वाले सात क्षमता स्तंभ।",
      },
      industries: {
        title: "हम जिन उद्योगों में सेवा करते हैं",
        subtitle: "जहाँ अपटाइम गैर-परक्राम्य है।",
      },
      careers: {
        title: "Olivine में करियर",
        subtitle: "40 वर्षों से अनदेखी समस्याओं को हल कर रही इंजीनियरिंग टीम से जुड़ें।",
        apply: "आवेदन करें",
        open_positions: "खुली पोजीशन",
      },
      blogs: {
        title: "इनसाइट्स",
        subtitle: "Olivine टीम से फील्ड नोट्स, रिसर्च और इंजीनियरिंग दृष्टिकोण।",
        read_more: "लेख पढ़ें",
      },
      testimonials: {
        title: "हमारे ग्राहक क्या कहते हैं",
        subtitle: "चार महाद्वीपों के महत्वपूर्ण संचालन अग्रणी Olivine पर भरोसा करते हैं।",
      },
      contact: {
        title: "संपर्क करें",
        subtitle: "हमारी इंजीनियरिंग डेस्क से बात करें।",
        name: "पूरा नाम",
        email: "ईमेल",
        company: "कंपनी",
        phone: "फ़ोन",
        subject: "विषय",
        message: "संदेश",
        submit: "भेजें",
        success: "धन्यवाद। हम एक कार्यदिवस के भीतर संपर्क करेंगे।",
        error: "कुछ गलत हुआ। कृपया पुन: प्रयास करें।",
      },
      demo: {
        title: "डेमो बुक करें",
        subtitle: "हमारे फील्ड इंजीनियरों के साथ 45-मिनट तकनीकी वॉकथ्रू — ऑन-साइट या रिमोट।",
        role: "आपकी भूमिका",
        industry: "उद्योग",
        product: "रुचि का उत्पाद",
        preferred_date: "पसंदीदा तिथि",
        submit: "डेमो बुक करें",
        success: "डेमो अनुरोध प्राप्त। हम 24 घंटे के भीतर पुष्टि करेंगे।",
      },
      footer: {
        tagline: "वास्तविक दुनिया की औद्योगिक चुनौतियों के लिए डीप तकनीक समाधान।",
        contact_label: "संपर्क",
        follow_label: "फॉलो",
        rights: "सर्वाधिकार सुरक्षित।",
      },
      admin: {
        title: "एडमिन कंसोल",
        login_title: "एडमिन लॉगिन",
        login_cta: "साइन इन",
        logout: "लॉगआउट",
        tabs: { contacts: "संपर्क संदेश", demos: "डेमो अनुरोध", applications: "आवेदन" },
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "hi"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
